// 1. Raw Brand Palette (Primitive Colors)
const palette = {
  // Brand Orange
  orange: '#FD8A36',         // Primary vibrant food orange
  orangePressed: '#E07324',  // Darker shade for buttons when pressed
  orangeLight: '#FFF2E0',    // Soft cream orange for light mode alerts/backgrounds
  orangeDark: '#3A1E0A',     // Deep orange accent for dark mode
  
  // Light Theme Specifics (Warm & Creamy)
  bgLightMain: '#FFFFFF',    // Main background
  bgLightTop: '#FFF4E6',     // Peach top gradient color (behind delivery scooter)
  textLightDark: '#2E2218',  // Deep espresso brown (much softer than pitch black)
  textLightGray: '#827064',  // Soft gray-brown for description text
  borderLight: '#F5E6DA',    // Warm light gray for card outlines
  cardLight: '#FFFFFF',      // Pure white for floating cards
  
  // Dark Theme Specifics (Warm Cocoa Charcoal)
  bgDarkMain: '#12100E',     // Deep cocoa background
  bgDarkTop: '#1E1712',      // Muted dark orange top gradient
  textDarkLight: '#F4EFEA',  // Cream white for readability
  textDarkGray: '#A39082',   // Muted cocoa-gray for secondary text
  borderDark: '#2A2017',     // Dark warm border outline
  cardDark: '#1C1611',       // Lighter dark brown-gray for cards
  
  // Veg / Non-Veg Indicators
  vegGreen: '#2E7D32',       // Green dot color
  nonVegRed: '#C62828',      // Red square/circle color
};

// 2. Semantic Theme Mappings (Used directly in your components)
export const Colors = {
  light: {
    primary: palette.orange,
    primaryPressed: palette.orangePressed,
    primaryLight: palette.orangeLight,
    
    // Backgrounds & Surfaces
    background: palette.bgLightMain,
    backgroundGradientStart: palette.orange,
    backgroundGradientEnd: palette.bgLightMain,
    card: palette.cardLight,
    cardBackground: palette.cardLight,
    backgroundColor: palette.bgLightMain,
    
    // Text
    text: palette.textLightDark,
    textSecondary: palette.textLightGray,
    textColor: palette.textLightDark,
    textColorSecondary: palette.textLightGray,
    textOnPrimary: '#FFFFFF',
    
    // UI Elements
    border: palette.borderLight,
    borderColor: palette.borderLight,
    borderActive: palette.orange,
    icon: palette.textLightDark,
    inputBackground: '#FFFFFF',
    inputBackgroundColor: '#FFFFFF',
    
    // Veg/Non-Veg
    veg: palette.vegGreen,
    nonVeg: palette.nonVegRed,
    
    // Additional
    secondary: palette.orange,
  },
  
  dark: {
    primary: palette.orange,
    primaryPressed: palette.orangePressed,
    primaryLight: palette.orangeDark,
    
    // Backgrounds & Surfaces
    background: palette.bgDarkMain,
    backgroundGradientStart: palette.bgDarkTop,
    backgroundGradientEnd: palette.bgDarkMain,
    card: palette.cardDark,
    cardBackground: palette.cardDark,
    backgroundColor: palette.bgDarkMain,
    
    // Text
    text: palette.textDarkLight,
    textSecondary: palette.textDarkGray,
    textColor: palette.textDarkLight,
    textColorSecondary: palette.textDarkGray,
    textOnPrimary: '#FFFFFF',
    
    // UI Elements
    border: palette.borderDark,
    borderColor: palette.borderDark,
    borderActive: palette.orange,
    icon: palette.textDarkLight,
    inputBackground: palette.cardDark,
    inputBackgroundColor: palette.cardDark,
    
    // Veg/Non-Veg
    veg: palette.vegGreen,
    nonVeg: palette.nonVegRed,
    
    // Additional
    secondary: palette.orange,
  },
};

// 3. Helper function to get colors based on theme
export const getColors = (isDark) => {
  return isDark ? Colors.dark : Colors.light;
};

// Default export for backward compatibility
const colors = Colors.light;
export default colors;